import React, {Fragment} from 'react';
import {EuiAccordion} from "@elastic/eui";
import ListSupportTicketsForAdmin from "../../support-tickets/list/list-admin-support-tickets.";
import {Ticket} from "../../../app/models/Ticket";

type OrderFormRelatedTicketsProps = {
    tickets: Ticket[],
    onCloseTicket: (ticket:Ticket) => void
}
const OrderFormRelatedTickets = ({tickets, onCloseTicket}: OrderFormRelatedTicketsProps) => {
    return (
        <Fragment>
            {(tickets && tickets.length>0) ? (
                <EuiAccordion
                    id="accordionForm1"
                    buttonClassName="euiAccordionForm__button"
                    buttonContent={"Support Tickets"}
                    paddingSize="l"
                >
                    <ListSupportTicketsForAdmin
                        items={tickets}
                        onCloseTicket={onCloseTicket}
                    />
                </EuiAccordion>
            ) : null}
        </Fragment>
    );
};

export default OrderFormRelatedTickets;